// extracted by mini-css-extract-plugin
module.exports = {"root":"video-module--root--2gPDj","marquee":"video-module--marquee--2u91e","image":"video-module--image--V7lED"};